export enum Color {
  Slate = '#081d34',
  Blue = '#0057ff',
  Gray = '#e6e6e6',
  Sky = '#c4e0fd',
  Stone = '#f1f1f1',
  CoralLight = '#ffa19f',
  VioletLight = '#96a4d8',
  Ice = '#bff5f8',
  TangerineLight = '#fcc692',
  SkyExtraLight = '#e4eefa',
  Coral = '#ff645f',
  Violet = '#4f66c2',
  Aqua = '#47c7f0',
  UIGray = '#a0a0a0',
  UIError = '#fc5b3f',
  UISuccess = '#6afdb3',
  UIWarning = '#ffd935',
  White = '#ffffff',
  Tangerine = '#fea143',
  Red = '#ff0000',
  Transparent = 'transparent',
}
